import React, { useEffect } from "react";
import BatchesStudentListing from "./BatchesStudentListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/BatchesStudentSlice";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import { useGetNotCompletedAssignmentsStudentsQuery } from "src/services/StudentServices";
import { useParams } from "react-router-dom";
import { isCheckColumnPermission } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import { Tooltip } from "@mui/material";

type Props = {};

const BatchesStudentListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.batchesStudent);
  const { batchId } = useParams();

  const { data, isLoading, isFetching } =
    useGetNotCompletedAssignmentsStudentsQuery({
      limit: rowsPerPage,
      searchValue: searchValue,
      batchId: batchId,
      params: ["name", "mobile", "email"],
      page: page,
      filterBy: [
        {
          fieldName: "batches.batchId",
          value: batchId,
        },
      ],
      dateFilter: {},
      orderBy: "createdAt",
      orderByValue: -1,
      isPaginationRequired: true,
    });

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
      dispatch(setRowsPerPage(data?.pageSize || 0));
      dispatch(setPage(data?.currentPage || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const columns: columnTypes[] = [
    // {
    //   field: "createdAt",
    //   headerName: "Date - Time",
    //   extraClasses: "py-1",
    //   flex: "flex-[1_1_0%]",
    //   renderCell: (row: any) => (
    //     <div>
    //       <div className="text-[13px] text-slate-700 font-medium">
    //         {formatedDateTimeIntoIst(row.createdAt, "DD MMM yyyy")}
    //       </div>
    //       <div className="text-[12px] font-medium text-slate-400">
    //         {formatedDateTimeIntoIst(row.createdAt, "hh:mm A")}
    //       </div>
    //     </div>
    //   ),
    // },
    {
      field: "name",
      headerName: "Name",
      flex: "flex-[1.5_1.5_0%] ",
    },
    // {
    //   field: "mobile",
    //   headerName: "Mobile Number",
    //   flex: "flex-[1.5_1.5_0%]",
    // },
    // {
    //   field: "email",
    //   headerName: "Email",
    //   flex: "flex-[1.5_1.5_0%]",
    //   extraClasses: "min-w-[250px]",
    // },
    {
      field: "isActive",
      headerName: "is-Active",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => {
        return (
          <div>
            {row?.isActive ? (
              row?.deactivatedFromBatchOnDate ? (
                <span className="font-medium text-red-700">No</span>
              ) : (
                <span className="text-green-700 font-medium">Yes</span>
              )
            ) : (
              <span className="font-medium text-red-700">No</span>
            )}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action On Date",
      flex: "flex-[1_1_0%]",
      extraClasses: " py-2",
      renderCell: (row: any) => {
        return (
    <div className="text-[14px] text-slate-700 font-medium" > { row.deactivatedFromBatchOnDate ? formatedDateTimeIntoIst(row.deactivatedFromBatchOnDate, "DD MMM yyyy") :  '-'}  </div>
        );
      },
    },
    {
      field: "notSubmittedAssignmentsCount",
      headerName: "Not Submitted Assignments",
      flex: "flex-[1.5_1.5_0%]",
      align: "center",
      extraClasses: "min-w-[250px]",
      renderCell: (row: any) => {
        return (
          <Tooltip title="Not Submitted Assignments">
            <span className="font-medium  text-red-600">
              {row?.notSubmittedAssignmentsCount || 0}
            </span>
          </Tooltip>
        );
      },
    },

    {
      field: "totalAssignments",
      headerName: "Total Assignments",
      flex: "flex-[1.5_1.5_0%]",
      align: "center",
      extraClasses: "min-w-[250px]",
      renderCell: (row: any) => {
        return (
          <Tooltip title="Total Assignments">
            <span className="font-medium"> {row?.totalAssignments || 0} </span>
            {/* <div className='bg-amber-400 px-2 rounded py-1 text-white font-medium'><span className=''>{row?.notSubmittedAssignmentsCount} </span> / <span>{row?.totalAssignments} </span> </div> */}
          </Tooltip>
        );
      },
    },
  ];
  return (
    <div>
      <BatchesStudentListing
        columns={isCheckColumnPermission({
          moduleName: UserModuleNameTypes.BATCHES,
          actionName: UserModuleActionTypes.BATCHES_STUDENTS_LIST,
          columns: columns,
        })}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
    </div>
  );
};

export default BatchesStudentListingWrapper;
